// https://day.js.org/docs/en/display/format

// Format
export const ISODateFormat = 'YYYY-MM-DD';
export const defaultDateFormat = 'MM/DD/YYYY';

// RegExp
export const ISODateRegExp = /[0-9]{4}-[0-9]{2}-[0-9]{2}/; // 'YYYY-MM-DD'
export const defaultDateRegExp = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/; // 'MM/DD/YYYY'
